module.exports = {"610525001":"城关街道","610525101":"冯原镇","610525102":"王庄镇","610525103":"尧头镇","610525104":"赵庄镇","610525105":"交道镇","610525106":"寺前镇","610525107":"韦庄镇","610525108":"安里镇","610525109":"庄头镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610525.json
// module id = 2618
// module chunks = 0